(function ($) {

    var $flashWrap = $('.flash--wrap');

    if ($flashWrap.length != -1) {

        setTimeout(function () {
            $flashWrap.fadeOut('3000');
        }, 3000);

    } else {
        console.log($flashWrap.length);
    }

})(jQuery);
